import { render, staticRenderFns } from "./Colorex.vue?vue&type=template&id=5f9743a4&"
import script from "./Colorex.vue?vue&type=script&lang=js&"
export * from "./Colorex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports